:host {
    display: block;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50%;
        background: linear-gradient(to bottom, transparent, black);
        opacity: 0;
        transition: opacity 200ms;
        z-index: 1;
    }

    ::slotted(sew-picture) {
        transition: transform 200ms;
        aspect-ratio: 16 / 9;
    }

    .link {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 24px;
        left: 27px;
        color: $color-white;
        transition:
            opacity 0.2s,
            transform 200ms;
        opacity: 0;
        transform: translate3d(-10px, 0, 0);
        z-index: 1;
    }

    ::slotted(a) {
        font-family: 'Helvetica Now Text', sans-serif;
        font-size: 28px;
        line-height: 36px;
        text-decoration: none;
        padding-left: 7px;
    }
}

:host(.no-link) {
    ::slotted(sew-picture) {
        height: 100%;
    }
}

:host(:hover:not(.no-link)) {
    cursor: pointer;

    &::before {
        opacity: 0.7;
    }

    ::slotted(sew-picture) {
        transform: scale(1.2);
    }

    .link {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}

@include mq-2 {
    :host {
        &::before {
            display: none;
        }

        .link {
            background-color: $color-grey-01-dark;
            position: relative;
            top: 0;
            left: 0;
            padding: 2px 0;
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }

        ::slotted(a) {
            @include typo-ws-paragraph-s;

            padding-left: 1px;
            transition: transform 0.2s;
        }

        svg {
            width: 16px;
            padding-left: 9px;
            transition: transform 0.2s;
            transform: translate3d(-3px, 0, 0);

            .shaft {
                opacity: 0;
                transition: opacity 0.2s;
            }
        }
    }

    :host(:hover:not(.no-link)) {
        ::slotted(a) {
            transform: translate3d(3px, 0, 0);
        }

        svg {
            transform: translate3d(0, 0, 0);

            .shaft {
                opacity: 1;
            }
        }
    }
}
